import { render } from "./HeroiconsOutlineChevronDoubleUp.vue?vue&type=template&id=fa3df07a"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleUp.vue"]])

export default __exports__